import React, { useEffect, useState } from 'react';
import Search from '../../components/input/Search';
import { deleteVoucher, searchVouchers } from '../../api/sportaloka-client';
import VoucherTable from './components/VoucherTable';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import ViewVoucherModal from './components/ViewVoucherModal';

function Voucher() {
  const [vouchers, setVouchers] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10,
    sort_field: 'updated_at',
    sort_value: 'desc',
    keyword: ''
  });

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setVouchers([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        keyword: paginationOptions.keyword
      }).toString();
      const response = await searchVouchers(query);
      const responseData = response.data.data.data;
      setVouchers(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const handleDelete = (val) => {
    Swal.fire({
      title: 'Apakah anda yakin ingin menghapus data?',
      text: 'Data yang dihapus tidak dapat dikembalikan, pastikan anda sudah yakin dengan aksi ini.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, hapus data!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setVouchers([]);
          await deleteVoucher(val);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: 'Data berhasil dihapus.',
            icon: 'success'
          });
        } catch (error) {
          if (error.response && error.response.data.code === '100403') {
            Swal.fire({
              title: 'Gagal!',
              text: 'Data ini digunakan oleh data yang berelasi.',
              icon: 'error',
              confirmButtonText: 'Tutup'
            });
          } else {
            Swal.fire({
              title: 'Gagal!',
              text: 'Periksa koneksi anda dan coba kembali.',
              icon: 'error',
              confirmButtonText: 'Tutup'
            });
          }
          await getData();
          setLoading(false);
        }
      }
    });
  };

  const handleSort = (field) => {
    const isAsc = paginationOptions.sort_field === field && paginationOptions.sort_value === 'asc';
    setPaginationOptions({
      ...paginationOptions,
      sort_field: field,
      sort_value: isAsc ? 'desc' : 'asc',
      page: 1
    });
  };

  const handleSearch = (val) => {
    setPaginationOptions({ ...paginationOptions, keyword: val, page: 1 });
  };

  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="text-30 lh-14 fw-600">Voucher</h1>
          <Link to="/voucher/create" className="button -md h-50 bg-blue-1 text-white">
            <i className="fa fa-plus mr-10" />
            Data Baru
          </Link>
        </div>
        <div className="row mt-20">
          <div className="col-12">
            <Search onSearch={handleSearch} label="Kata Kunci (Kode/Judul)" />
          </div>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20">
          <VoucherTable
            handleSort={handleSort}
            handlePageChange={handlePageChange}
            handleRefresh={getData}
            onDelete={handleDelete}
            onSelectedData={(val) => {
              setSelectedData(null);
              setTimeout(() => {
                setSelectedData(val);
              }, 100);
            }}
            paginationOptions={paginationOptions}
            loading={loading}
            error={error}
            data={vouchers}
            totalRows={totalRows}
          />
          <ViewVoucherModal data={selectedData} />
        </div>
      </div>
      {/* End .col-12 */}
    </div>
  );
}

export default Voucher;
